import { Calendar, CalendarProps } from '@/components/ui/calendar';

export default function DatePickerFallback({
  date,
  currentMonth,
  onSelect,
  setCurrentMonth,
  ...calendarProps
}: {
  date: Date;
  currentMonth: Date;
  onSelect: (date: Date) => void;
  setCurrentMonth: (month: Date) => void;
} & CalendarProps) {
  return (
    <Calendar
      {...calendarProps}
      month={currentMonth}
      classNames={{
        head_cell: 'text-neutrals-N600 w-9 font-normal text-xs',
        day_outside: 'text-neutrals-N600',
      }}
      mode="single"
      defaultMonth={date}
      selected={date}
      onSelect={(d) => {
        onSelect(d);
      }}
      onMonthChange={(month) => setCurrentMonth(month)}
    />
  );
}
